import React from 'react'

export default (html) => (<span className="dangerously-inserted" dangerouslySetInnerHTML={{ __html: html }} />)
